import { checkSkipIngameLimitedTime } from '@utiles/officialTopupNew/ingameLimitedExtra';

export default {
    computed: {
        letter() {
            return this.$store.state.letter;
        },
        skipIngameLimitedTimeCheck() {
            return checkSkipIngameLimitedTime();
        },
        ingameLimitedText() {
            if (this.skipIngameLimitedTimeCheck) {
                return this.letter.v3IngameLimitedExtraCoinLabel;
            }
            return this.letter.v3IngameLimitedExtraCoin;
        }
    },
};